<template>
  <div>
    <v-card class="white elevation-3 ma-4">
      <toolbar
          :filters="filters"
          @search="searchStations"
          @add="addNew"
      />
    </v-card>
    <v-card class="ma-4">
      <stations-table
          ref="stations"
          :filters="filters"
          @edit="editStation"
          @delete="deleteStation"
          @clickItems="showUnits"
      />
    </v-card>
    <edit-station-popup
        ref="editStationPopup"
        @saved="$refs.stations.fetchData()"
    />
    <units-list-popup ref="unitsListPopup" />
    <confirmation ref="confirmationPopup"/>
  </div>
</template>
<script>
import _ from 'lodash';
import StationsTable from '@/components/Neris/Stations/StationsTable';
import Toolbar from '@/components/Neris/Stations/Toolbar';
import { SET_TITLE } from '@/store/mutations';
import EditStationPopup from '@/components/Neris/Stations/EditStationPopup';
import Confirmation from '@/components/Confirmation';
import neris from '@/api/neris';
import UnitsListPopup from '@/components/Neris/Units/UnitsListPopup';

export default {
  components: {
    UnitsListPopup,
    Confirmation,
    EditStationPopup,
    Toolbar,
    StationsTable,
  },
  data() {
    return {
      loading: true,
      filters: {
        search: null,
      },
    };
  },
  methods: {
    searchStations(filters) {
      this.filters = filters;
    },
    addNew() {
      this.$refs.editStationPopup.show();
    },
    editStation(station) {
      const stationData = _.cloneDeep(station);
      this.$refs.editStationPopup.show(station.id, stationData);
    },
    showUnits(station) {
      this.$refs.unitsListPopup.show(station);
    },
    deleteStation(station) {
      this.$refs.confirmationPopup.showConfirm(
        'Confirmation',
        `Are you sure you want to delete the station ${station.stationId}?`,
        async () => {
          await neris.deleteStation(station.id);
          await this.$refs.stations.fetchData();
        },
      );
    },
  },
  mounted() {
    this.$store.commit(SET_TITLE, 'NERIS Stations');
  },
};
</script>
